export default "__VITE_ASSET__BQI3AMzT__"